import React from 'react';
import { Menu, X } from 'lucide-react';

const Header = ({ currentPage, setCurrentPage, pages, mobileMenuOpen, setMobileMenuOpen, nomUsine }) => {
  return (
    <header className="header">
      <div className="header-content">
        {/* Logo Nitrokym avec image */}
        <button
          className="logo"
          onClick={() => setCurrentPage('accueil')}
          aria-label="Nitrokym - Retourner à l'accueil"
          type="button"
        >
          {/* Image du logo */}
          <img 
            src="/images/nitrokym.png" 
            alt="Nitrokym Logo" 
            className="logo-img"
            onError={(e) => {
              if (process.env.NODE_ENV === 'development') {
                console.error("Erreur de chargement de l'image:", e.target.src);
              }
              e.target.style.display = 'none';
              if (e.target.nextElementSibling) {
                e.target.nextElementSibling.style.display = 'flex';
              }
            }}
          />
          
          {/* Texte fallback si l'image ne charge pas */}
          <div className="logo-text-container" style={{ display: 'none' }}>
            <div className="logo-main">{nomUsine}</div>
            <div className="logo-sub">Chimie des Chlor-Alkalis</div>
          </div>
        </button>

        {/* Navigation Desktop */}
        <nav className="nav-desktop" role="navigation" aria-label="Navigation principale">
          {pages.map(page => (
            <button
              key={page.id}
              onClick={() => setCurrentPage(page.id)}
              className={`nav-link ${currentPage === page.id ? 'active' : ''}`}
              aria-current={currentPage === page.id ? 'page' : undefined}
            >
              {page.label}
            </button>
          ))}
        </nav>

        {/* Bouton Menu Mobile */}
        <button 
          className="menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label={mobileMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
          aria-expanded={mobileMenuOpen}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Menu Mobile */}
      {mobileMenuOpen && (
        <nav className="mobile-menu" role="navigation" aria-label="Navigation mobile">
          {pages.map(page => (
            <button
              key={page.id}
              onClick={() => {
                setCurrentPage(page.id);
                setMobileMenuOpen(false);
              }}
              className={`mobile-nav-link ${currentPage === page.id ? 'active' : ''}`}
              aria-current={currentPage === page.id ? 'page' : undefined}
            >
              {page.label}
            </button>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Header;